import axios from 'axios';

import { 
  getCpapApiEndpoint, 
  setAxiosDefaultHeaders 
} from './apiBaseUtilities';
import { getFilteredAssesments } from './apiGetUtilities';

import { deleteCloudVideo } from './utilities';
import { FirebaseUserProps } from './entityUtilities';
import { debugLog } from './debugUtilities';
import { getSubjectDetails } from './apiGetUtilities';
import { AssessmentSchemaProps } from './mongoSchemas';
const cpapApiEndpoint = getCpapApiEndpoint();



export async function deleteUserAccount(firebaseUser: any){
  
    debugLog('Deleting user account');
    firebaseUser?.firebaseUserObject.delete().then ( ()=>{
      debugLog('User deleted');
    }).catch((err:any)=>{
    debugLog('Error at API:', err);
    });
  
  }

  export async function deleteAssessment(firebaseUser:FirebaseUserProps, assessmentId:string){
    if(!cpapApiEndpoint){
      return false;
    }
  
    const url = `${cpapApiEndpoint}assessments/${assessmentId}`;
    try{
      const {uid, bearerToken } = firebaseUser;
      setAxiosDefaultHeaders(uid, bearerToken);
      const response = await axios.delete(url);
  
      // debugLog('The respons', response);
      if(response.status === 204){
        debugLog('Deleted asmt');
        return true;
      }
  
      return false;
    }catch(error){
      debugLog('API ERROR:',error);
    }
    return false;
  }


  async function deleteSubject(firebaseUser: FirebaseUserProps, subjectId:string) {

    let baseUrl = `${cpapApiEndpoint}subjects/${subjectId}`;
    let url = baseUrl;
  
    debugLog('Delete URL:', url);
  
  
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    try{
      const response = await axios.delete(url);
  
      if(response.status === 204){
        debugLog('Deleted subject:', subjectId);
        return true;
      }
    } catch(err) 
    {debugLog('API error at:', url)}
  }
  
  async function deleteCribsyUser(firebaseUser: FirebaseUserProps, emmauserId:string) {

    let baseUrl = `${cpapApiEndpoint}users/${emmauserId}`;
    let url = baseUrl;
  
    debugLog('Delete URL:', url);
    
  
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    try{
      const response = await axios.delete(url);
  
      if(response.status === 204){
        debugLog('Deleted Cribsy User:', emmauserId);
        return true;
      }
    } catch(err) 
    {debugLog('API error at:', url)}
  }

  export async function deleteAllData(firebaseUser: FirebaseUserProps, userState:any, userDispatch:any){
    if(!cpapApiEndpoint || !firebaseUser){
      return;
    }
  
    let baseUrl = `${cpapApiEndpoint}/assessments`;
    let url = baseUrl;
  
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    let asmts:AssessmentSchemaProps[] = [];
    let subjectId:string|undefined = '';
  
  
  
    //get subject from this user's id
    let subjectForParent = await getSubjectDetails(firebaseUser, userState?._id);
    debugLog('Subject found for parent:', subjectForParent);
    subjectId = subjectForParent?._id;
    debugLog('subjectId:', subjectId);
  
    //what if subjectForParent is not found?
    //then, subjectId will be null or undefined. that is taken care of below

    if (subjectId == '' || subjectId == null || subjectId == undefined){    
        return;
    }

    const parentEmail = userState?.localEmail;
    debugLog('Parent email:', parentEmail);

    if (parentEmail == '' || parentEmail == null || parentEmail == undefined){
        return;
    }

    const videosToDelete:string[] = [];

    try{
  
      const filter = {subjectId: subjectId};
      const asmts = await getFilteredAssesments(firebaseUser, parentEmail, JSON.stringify(filter));
        debugLog('Asmts:', asmts);
        for (const asmt of asmts ?? []) {
            debugLog('asmt:', asmt);
            // delete asmt
            let asmtId: any = asmt?._id;
            debugLog('Delete asmtid:', asmtId);
            debugLog('Asmt subject:', asmt?.subjectId);
            if (asmt?.subjectId == subjectId && (subjectId != null && subjectId != undefined)) {
                debugLog('Asmt subjectid:', asmt?.subjectId);
                debugLog('Subject for this parent:', subjectId);
                debugLog('Deleting asmt:', asmtId);
                //
                // WARNING: This is the line that deletes the assessment
                await deleteAssessment(firebaseUser, asmtId);
                const videoUrl = asmt?.video;
                if(videoUrl != '' && videoUrl != null && videoUrl != undefined){

                    const urlArray = asmt?.resulturl ? asmt?.resulturl.split('|') : '';
                    // resulturl is a pipe separated string of urls, one for pose overlay and
                    // another for suprise.json
                    // do you want to delete the original video, which is videoUrl?
                    for (const url of urlArray){
                      videosToDelete.push(url);
                    }
                }
            }
        }
  
    } catch(err){
      debugLog('API error at :', url);
    }

    finally {
        
        // delete subject
        const subjectToDelete:any = subjectId;
        debugLog('Subject to delete:', subjectToDelete);
        // WARNING: This is the line that deletes the subject
        await deleteSubject(firebaseUser, subjectToDelete);
      
  
      //debugLog('Deleting notifications for emmauser:', userState?.userId);
      //await deleteNotifications(firebaseUser, userState?.userId);
  
      //finally, delete cribsyuser
      if (userState?.userId != undefined && userState?.userId != null){
        debugLog('Cribsy user to delete:', userState?._id);
        // WARNING: This is the line that deletes the cribsy user
        await deleteCribsyUser(firebaseUser, userState._id);
  
      }

    
      //delete videos
      try{
      for (const videoUrl of videosToDelete){
        deleteCloudVideo(firebaseUser, videoUrl);
      }
      }
      catch(err){
        debugLog('Error deleting videos:', err);
      }
    }
  
  }

  export async function deleteNotifications(firebaseUser:any, emmauserId: string){


    const url = `${cpapApiEndpoint}/notifications`;
    //the api gets notifications for the user specified by the uid in the axios headers
    
    debugLog('Delete notifications URL:', url);
    
  
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    try{
  
      const response = await axios.get(url);
      let alerts = response.data;
      for (const alert of alerts){
        debugLog('notification:', alert);
        //delete?
        let notId = alert.notificationId;
  
        debugLog('Deleting notification:', notId);
        await deleteNotification(firebaseUser, notId);
      }
  
    }catch(err){
      debugLog('Error deleting notifications:', err);
    }
  
  }

export async function deleteNotification(firebaseUser: FirebaseUserProps, notificationId: string){

  if(!cpapApiEndpoint){
    return false;
  }

  const url = `${cpapApiEndpoint}notifications/${notificationId}`;
  try{
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    const response = await axios.delete(url);

    // debugLog('The respons', response);
    if(response.status === 204){
      debugLog('deleted notification:', notificationId);
      return true;
    }

    return false;
  }catch(error){
    debugLog('API ERROR:',error);
  }
  return false;
}
